<template lang="pug">
  v-container
    v-tabs(
      v-model="tab"
      :background-color="$vuetify.theme.dark ? '#303030' : 'white'"
      :color="$vuetify.theme.dark ? 'white' : 'secondary'"
      show-arrows
    ).mb-3
      v-tab Мои реквизиты
      v-tab Политики и положения
    v-tabs-items(v-model="tab")
      v-tab-item
        bank-details
      v-tab-item
        contract-documents
</template>
<script>

import BankDetails from '@/modules/PaymentSystem/components/BankDetails.vue';
import ContractDocuments from '@/modules/PaymentSystem/components/ContractDocuments.vue';

export default {
  components: {
    BankDetails,
    ContractDocuments,
  },
  data() {
    return {
      tab: null,
    };
  },
};
</script>
